import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService, Message } from 'primeng/api';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { UpdatePassword } from 'src/app/_models/auth/updatePassword';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { UpdatePasswordResponse } from 'src/app/_models/auth/updatePasswordResponse';
import { ParamMap, Router, ActivatedRoute } from '@angular/router';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';

@Component({
  templateUrl: 'alterarsenha.component.html',
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService]
})


export class AlterarSenhaComponent implements OnInit {

  updatePassword: UpdatePassword;
  currentUsuario: Usuario;
  msgs: Message[] = [];
  strCodUsuario: string;
  codUsuario: number;
    constructor(private usuarioService: UsuarioService, private messageService: MessageService,
                private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
                private authenticationService: AuthenticationService, private router: Router,
                private route: ActivatedRoute,  private bscobrancaTranslate: BscobrancaTranslate) {

              }

   ngOnInit(): void {
    this.updatePassword = {};
    this.strCodUsuario = this.route.snapshot.queryParamMap.get('ident');
    this.codUsuario = + this.strCodUsuario;

   }

   update() {
     this.currentUsuario = this.authenticationService.atualUserValue;
     const error = this.validateUpdate();
     if (error !== '') {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Erro:', detail: error });
     } else {
       this.updatePassword.usuario = this.currentUsuario;
       this.authenticationService.atualizarSenha(this.updatePassword).subscribe(
          (updatePasswordResponse: UpdatePasswordResponse) => {
              if (updatePasswordResponse) {
                  if (updatePasswordResponse.codigo === 0) {
                    this.authenticationService.replaceUser(updatePasswordResponse.usuario);
                    const perfil = this.authenticationService.atualUserPerfilValue;
                    if (perfil.nmePerfil === 'CONSSACADO') {
                      this.router.navigate(['sacado/sacado']);
                    } else {
                        this.router.navigate(['titulo/pesquisatitulo']);
                    }
                  } else {
                    this.msgs = [];
                    this.msgs.push({ severity: 'error', summary: 'Erro:', detail: updatePasswordResponse.mensagem });
                  }
              } else {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Erro:', detail: updatePasswordResponse.mensagem });
              }
          });
     }

   }

  validateUpdate() {
    if (!this.updatePassword) {
      return this.bscobrancaTranslate.getText('usuario.camposdevempreeenchidos');
    }
    if (!this.updatePassword.oldPassword) {
      return this.bscobrancaTranslate.getText('usuario.senhaantigapreenchida');
    }
    if (!this.updatePassword.newPassword) {
       return this.bscobrancaTranslate.getText('usuario.senhanovapreenchida');
    }
    if (!this.updatePassword.confNewPassword) {
      return this.bscobrancaTranslate.getText('usuario.confirmacaosenhapreenchida');
    }
    return '';
  }

}
